export default __webpack_public_path__ + "static/media/instaWhite.b856d0e6.svg";